import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'items',
            name: 'item',
            class: 'Modules\\Ecommerce\\Entities\\Item',
            buyables: []
        }
    },

    methods: {
        allBuyables() {
            if(this.buyables.length) {
                return Promise.resolve(this.buyables)
            }

            return axios({
                method: 'get',
                url: route('api.items.all.buyables')
            })
            .then(response => {
                this.$set(this, 'buyables', response.data.data)
                return this.buyables
            })
        }
    }
}